import React, { useCallback, useMemo } from "react";
import { useDropzone } from "react-dropzone";
import Papa from "papaparse";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";

import * as styles from "./dropzone.css";
import { Grid, Paper, Typography } from "@mui/material";

interface DropzoneProps {
  onChange: (data: string[][], pdfFile?: File) => void;
  allowPdf?: boolean;
  loading: boolean;
  copies: {
    undropped: string | React.ReactNode;
    dropped: string;
  };
}

export function Dropzone({
  onChange,
  copies,
  allowPdf,
  loading,
}: DropzoneProps) {
  const { undropped, dropped } = copies;
  const onDrop = useCallback((acceptedFiles: File[]) => {
    if (acceptedFiles[0].type === "application/pdf") {
      onChange([], acceptedFiles[0]);
      return;
    }

    Papa.parse(acceptedFiles[0], {
      complete: function (results) {
        onChange(results.data as string[][]);
      },
    });
  }, []);
  const allowedFormats = useMemo(() => {
    return !allowPdf ? [".csv", ".xlsx"] : [".csv", ".xlsx", ".pdf"];
  }, [allowPdf]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "text/csv": allowedFormats,
    },
  });

  return (
    <Paper
      {...getRootProps({ disabled: !!loading })}
      className={styles.dropzoneWrapper}
    >
      <div className={styles.dropzone}>
        <input
          {...getInputProps({
            multiple: false,
          })}
        />
        {isDragActive ? (
          <Typography align="center">{dropped}</Typography>
        ) : (
          <Grid container direction="column" alignItems="center">
            <DriveFolderUploadIcon fontSize="large" />
            <Typography align="center">
              {loading ? "Loading..." : undropped}
            </Typography>
          </Grid>
        )}
      </div>
    </Paper>
  );
}
